import React from 'react'
import { useFormik } from 'formik'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ResponsiveModal from 'presentation/shared/components/ResponsiveModal'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as SearchIcon } from 'presentation/assets/icons/search.svg'
import * as S from './styles'
import { cpfMask } from 'presentation/utils/masks'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import validationSchema from './validationSchema'
import { unformatCpf } from 'common/utils/format-cpf'

type PatientConfirmationResponsiveModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: (cpf: string) => void
}

const PatientConfirmationResponsiveModal = ({
  isOpen,
  onClose,
  onConfirm
}: PatientConfirmationResponsiveModalProps) => {
  const formik = useFormik({
    initialValues: {
      cpf: ''
    },
    validationSchema: validationSchema,
    validateOnChange: true,
    onSubmit: async (values) => {
      const cleanCPF = unformatCpf(values.cpf)
      !!cleanCPF && onConfirm && onConfirm(cleanCPF)
      formik.resetForm()
    }
  })

  const handleClose = () => {
    formik.resetForm()
    onClose()
  }

  return (
    <ResponsiveModal
      isOpen={isOpen}
      title="Confirmar seleção de paciente"
      onClose={handleClose}
      onConfirm={formik.submitForm}
      confirmButtonLabel="Confirmar Seleção"
      confirmButtonType="submit"
      disableConfirmButton={!formik.isValid}
      cancelButtonLabel="Fazer outra busca"
      width={500}
    >
      {(isMobile) => (
        <>
          <HeadingNew
            size={isMobile ? 'medium' : 'large'}
            color="textPrimary"
            fontFamily="secondary"
          >
            Sua busca retornou mais de 1 paciente
          </HeadingNew>
          <SupportTextNew
            color="textSecondary"
            fontFamily="secondary"
            style={{ marginTop: isMobile ? '8px' : '16px' }}
          >
            {/* TODO: Mudar mensagem caso seja RN ("CPF da mãe") */}
            Por segurança, por favor, digite abaixo o CPF do paciente para
            prosseguir com a criação do pedido:
          </SupportTextNew>

          <S.Form onSubmit={formik.handleSubmit}>
            <TextFieldNew
              labelOverlapping
              labelSize="xxsmall"
              labelWeight="semiBold"
              labelColor="textSecondary"
              requiredColor="textSecondary"
              label="CPF"
              name="cpf"
              placeholder="Digite CPF"
              value={formik.values.cpf}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              mask={cpfMask}
              icon={<SearchIcon />}
              iconPosition="insideLeft"
              iconColor="neutral600"
              error={formik.touched.cpf && formik.errors.cpf}
              required
              height="40px"
            />
          </S.Form>
        </>
      )}
    </ResponsiveModal>
  )
}

export default PatientConfirmationResponsiveModal
